<template>
  <div class="app-container">
    <el-form v-model="queryForm" :inline="true" class="query-form">
      <el-form-item>
        <el-input v-model="queryForm.keyword" clearable type="text" placeholder="租户编码 或 名称" />
      </el-form-item>
      <el-button type="primary" @click="handleSearch">
        <i class="el-icon-search" />查询
      </el-button>
    </el-form>
    <el-divider class="query-form-divider" />
    <div class="query-button-wrap">
      <el-button type="success" @click="handleCreateNew" class="margin-bottom-20">
        <i class="el-icon-plus" />新建
      </el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" border stripe fit highlight-current-row @sort-change="sort">
      <!-- <el-table-column label="id" width="80" prop="id" sortable /> -->
      <el-table-column label="租户编码" prop="tenancyName" />
      <el-table-column label="租户名称" prop="name" />
      <el-table-column label="启用" prop="isActive">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isActive ? 'success' : 'danger'" disable-transitions>{{ scope.row.isActive }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page.sync="page" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total,jumper,prev, pager, next,sizes" :total="totalCount" @size-change="handleSizeChange" @current-change="current_change" />
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="form.visible" :close-on-click-modal="false">
      <el-form ref="dataForm" :rules="form.rules" :model="form.data" label-position="top">
        <el-form-item label="租户编码" prop="tenancyName">
          <el-input v-model="form.data.tenancyName" />
        </el-form-item>
        <el-form-item label="租户名称" prop="name">
          <el-input v-model="form.data.name" />
        </el-form-item>
        <el-form-item v-if="dialogStatus==='create'" label="管理员邮箱" prop="adminEmailAddress">
          <el-input v-model="form.data.adminEmailAddress" />
        </el-form-item>
        <el-form-item v-if="dialogStatus==='create'" label="数据库连接字符串" prop="connectionString">
          <el-input v-model="form.data.connectionString" />
        </el-form-item>
        <el-form-item label="是否启用" prop="isActive">
          <el-switch v-model="form.data.isActive" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="default" @click="form.visible = false">取消</el-button>
        <el-button type="primary" @click="dialogStatus==='create'?handleSave():handleSave()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const defaultData = {
  id: 0,
  tenancyName: "",
  name: "",
  adminEmailAddress: "",
  connectionString: "",
  isActive: true
};

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger"
      };
      return statusMap[status];
    }
  },
  data() {
    return {
      list: null,
      listLoading: true,
      pagesize: 20,
      page: 1,
      totalCount: 0,
      sorting: "id descending",
      dialogStatus: "",
      queryForm: {
        keyword: ""
      },
      form: {
        visible: false,
        submitting: false,
        data: {
          ...defaultData
        },
        rules: {
          tenancyName: [
            {
              required: true,
              message: "TenancyName is required",
              trigger: "change"
            }
          ],
          name: [
            {
              required: true,
              message: "Name is required",
              trigger: "change"
            }
          ],
          adminEmailAddress: [
            {
              required: true,
              message: "AdminEmailAddress is required",
              trigger: ["blur", "change"]
            },
            {
              type: "email",
              message: "请输入正确的邮箱地址",
              trigger: ["blur", "change"]
            }
          ]
        }
      },
      dialogFormVisible: false,
      textMap: {
        update: "Edit",
        create: "Create"
      }
    };
  },
  watch: {
    page: function(val) {
      this.fetchData(val);
    }
  },
  created() {
    this.fetchData(); // 如果开启了默认排序,不需要这一行
  },
  methods: {
    fetchData(page = 1) {
      const that = this;
      this.listLoading = true;
      this.$abpApi.tenant
        .getAll({
          SkipCount: (page - 1) * that.pagesize,
          sorting: that.sorting,
          maxResultCount: that.pagesize,
          keyword: that.queryForm.keyword
        })
        .then(response => {
          this.list = response.data.items;
          this.totalCount = response.data.totalCount;
          this.listLoading = false;
        });
    },
    // 切换切面,在watch中监听 page
    current_change(e) {
      this.page = e;
    },
    // 排序
    sort(e) {
      console.log("sort : ", e);
      if (e.prop && e.order) {
        this.sorting = `${e.prop} ${e.order}`;
      } else {
        this.sorting = "id descending";
      }
      this.fetchData(1);
    },
    handleSizeChange(e) {
      this.pagesize = e;
      this.fetchData(1);
    },
    handleSearch() {
      this.fetchData(1);
    },
    handleCreateNew() {
      this.resetForm();
      this.dialogStatus = "create";
      this.form.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    handleEdit($index, $row) {
      this.resetForm();
      const { id } = $row;
      this.$abpApi.tenant
        .get({
          id
        })
        .then(res => {
          this.form.data = res;
          this.dialogStatus = "update";
          this.form.visible = true;
          this.$nextTick(() => {
            this.$refs["dataForm"].clearValidate();
          });
        });
    },
    handleSave() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          console.log(this.form.data);
          let fn;
          if (this.form.data.id) {
            fn = this.$abpApi.tenant.update;
          } else {
            fn = this.$abpApi.tenant.create;
          }
          fn(this.form.data).then(res => {
            this.form.submitting = false;
            this.form.visible = false;
            this.fetchData();
          });
        }
      });
    },
    handleDelete($index, $row) {
      const { id } = $row;
      this.$confirm("您确认要删除吗", "删除提示").then(() => {
        this.$abpApi.tenant
          .delete({
            id
          })
          .then(res => {
            console.log("delete then");
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.fetchData();
          });
      });
    },
    resetForm() {
      this.form = Object.assign({}, this.form, {
        data: {
          ...defaultData
        }
      });
    }
  }
};
</script>
